interface NativeAppUpdate {
  status: NativeUpdateStatus;
  recommendedVersion: string | null;
}

export const useNativeAppUpdate = () =>
  useState<NativeAppUpdate>('nativeAppUpdate', () => ({
    status: 'none',
    recommendedVersion: null,
  }));
